// core
import React from 'react';
import { Link } from 'react-router-dom'
import { Provider } from "react-redux"

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// page-specific
import FormBuilder from 'components/marketing/surveys/form_builder/FormBuilder';

class SurveyEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'edit',
      working: false,
      fetching: false,

      error: '',

      productGroups: {},

      survey: {
        title: '',
        descr: '',

        form: {
          schema: {
            fields: [
              // {
              //   type: 'text',
              //   label: '1. question ',
              //   placeholder: 'Riempi questo campo',
              //   help: 'Help now!'
              // },
              // {
              //   type: 'text',
              //   label: '2. Second question'
              // },
              // {
              //   type: 'textarea',
              //   label: '3. Another question'
              // },
              // {
              //   type: 'radio',
              //   label: '4. another?',
              //   options: [
              //     {label: 'option 1', value: 'ABC'},
              //     {label: 'option 2', value: 'easy as'},
              //     {label: 'option 3', value: '123'},
              //   ]
              // },
              // {
              //   type: 'checkbox',
              //   label: '5. You almost finished',
              //   options: [
              //     {label: 'option 1', value: 'ABC'},
              //     {label: 'option 2', value: 'easy as'},
              //     {label: 'option 3', value: '123'},
              //   ]
              // },
              // {
              //   type: 'radio',
              //   label: '6. This is the last one',
              //   options: [
              //     {label: 'option 1', value: 'ABC'},
              //     {label: 'option 2', value: 'easy as'},
              //     {label: 'option 3', value: '123'},
              //   ]
              // }
            ]
          }
        }
      }
    };

    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescrChange = this.handleDescrChange.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);

    this.handleSchemaChange = this.handleSchemaChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { surveyId } = this.props.match.params;

    this.setState({
      fetching: true
    });

    if (surveyId) {
      API.call('GET', Settings.V3_API_URL + '/surveys/' + surveyId, {}, (response, error) => {
        if (error) {
          this.setState({
            fetching: false,

            error: error.message + ' while gettings projects'
          });

          return false;
        }

        // convert form to object
        var survey = response.data.survey;
        survey.form = JSON.parse(survey.form);

        this.setState({
          survey: survey
        });
      });
    }

    // get kits to populate "product_id" menu
    let productGroups = {};

    this.props.appData.cache.kitGroups.forEach((group, i) => {
      var productGroup = {
        name: group.name,
        products: this.props.appData.cache.kitsByGroup[group.id] || []
      }

      productGroups[group.id] = productGroup;
    });

    // TODO: sort mother fucking groups

    this.setState((prevState) => {
      prevState.productGroups = productGroups;

      return prevState;
    });
  }

  handleTitleChange(e) {
    var title = e.target.value;

    return this.setState((prevState) => {
      prevState.survey.title = title;

      return prevState;
    });
  }
  handleDescrChange(e) {
    var descr = e.target.value;

    return this.setState((prevState) => {
      prevState.survey.descr = descr;

      return prevState;
    });
  }

  handleProductChange(e) {
    var productId = e.target.value;

    return this.setState((prevState) => {
      prevState.survey.product_id = productId;

      return prevState;
    });
  }

  handleSchemaChange(schema) {
    if (!this.state.survey || !this.state.survey.form) {
      console.log('no survey');

      return;
    }

    this.setState((prevState) => {
      prevState.survey.form.schema = schema;

      return prevState;
    });
  }

  handleSubmit() {
    this.setState({
      fetching: true,
      error: ''
    });

    let method, endpoint;
    if (this.state.survey.id) {
      method = 'PUT';
      endpoint = Settings.V3_API_URL + '/surveys/' + this.state.survey.id;
    } else {
      method = 'POST';
      endpoint = Settings.V3_API_URL + '/surveys';
    }

    let payload = this.state.survey;
    payload.form = JSON.stringify(payload.form);

    API.call(method, endpoint, payload, (response, error) => {
      this.setState({
        fetching: false
      });

      const err = error ? error.message : response.error;

      if (err) {
        this.setState({
          error: err
        });

        return false;
      }

      let survey = response.data.survey;
      survey.form = JSON.parse(survey.form);
      this.setState({
        status: 'saved',
        survey: survey
      });
    });
  }

  render() {
    const form = this.state.survey.form;

    // populate product dropdown
    var options = [<option value="">--sel--</option>];
    var keys = Object.keys(this.state.productGroups);
    for (var i=0; i<keys.length; i++) {
      var group = this.state.productGroups[keys[i]];
      var opts = group.products.map((product) => {
        return (
          <option value={product.id}>
            {product.schoolyear + '-' + (product.schoolyear+1) + ': ' + product.name}
          </option>
        );
      });

      options.push((
        <optgroup label={group.name}>
          {opts}
        </optgroup>
      ));
    }

    return (
      <div>
        <div className="container">
          {
            this.state.error ? (
              <div className="alert alert-danger"><h2>Oh, mamma!</h2><p>{this.state.error}</p></div>
            ) : ""
          }

          {
            this.state.status == 'edit' ? (
              <div>
                <div className="row">
                  <div className="col-md-8">
                    <h1><i className="fa fa-stream" /> {this.state.survey && this.state.survey.id ? "Aggiorna sondaggio" : "Crea nuovo sondaggio"}</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    {
                      // this.state.fetching || this.state.working ? <Spinner message="Attendere..." /> : ""
                    }
                  </div>
                </div>

                <div className="mt-4">
                  <div className="form-group">
                    <label for="survey_editor_survey_title">Titolo <span className="text-danger">*</span></label>

                    <input className="form-control" type="text" id="survey_editor_survey_title" value={this.state.survey ? this.state.survey.title : ""} onChange={this.handleTitleChange} />
                  </div>
                  <div className="form-group">
                    <label for="survey_editor_survey_descr">Descrizione/introduzione</label>

                    <textarea className="form-control" id="survey_editor_survey_descr" value={this.state.survey ? this.state.survey.descr : ""} onChange={this.handleDescrChange}></textarea>
                  </div>

                  <div className="form-group">
                    <label for="survey_editor_survey_product">Kit</label>

                    <select className="form-control" id="survey_editor_survey_product" value={this.state.survey && this.state.survey.product_id ? this.state.survey.product_id : ""} onChange={this.handleProductChange}>
                      {options}
                    </select>
                  </div>

                  <h2>Domande sondaggio</h2>

                  <FormBuilder schema={form.schema} onChange={this.handleSchemaChange} />

                  <hr />

                  <p><button className="btn btn-primary" onClick={this.handleSubmit}><i className="fa fa-save mr-1" /> Salva sondaggio</button></p>
                </div>
              </div>
            ) : this.state.status == 'saved' ? (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <h1>Sondaggio salvato.</h1>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <h3><Link to={'/marketing/surveys/' + this.state.survey.id + '/view/-/'}><i className="fa fa-arrow-right" /> Vai al sondaggio</Link></h3>
                    <p>oppure</p>
                    <h3><Link to="/marketing/surveys/new/"><i className="fa fa-plus" /> Crea nuovo sondaggio</Link></h3>
                  </div>
                </div>
              </div>
            ) : ""
          }
        </div>
      </div>
    );
  }
}

export default SurveyEditorPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/surveys/SurveyEditorPage.js